@if (measures) {
  <div class="row">
    <div class="field">
      <label soho-label>{{'SelectAMeasure' | translate}}</label>
      <select
        soho-dropdown
        [ngClass]="'dropdown-md'"
        id="measures"
        [(ngModel)]="measure"
        >
        @for (measure of measures; track measure) {
          <option [value]="measure.name">{{measure.name}}</option>
        }
      </select>
    </div>
  </div>
  <div class="row">
    <div class="field twelve columns">
      <label soho-label>{{'TestResult' | translate}}</label>
      <input
        soho-input
        id="testMeasure"
        [(ngModel)]="testResult"
        />
        <button
          soho-button="primary"
          style="margin-left: 8px"
          (click)="testMeasure()"
        >{{ 'TestMeasure' | translate}}</button>
      </div>
    </div>
  }
